"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require("semantic-ui-react");

var _Icone = require("../elements/Icone");

var _Icone2 = _interopRequireDefault(_Icone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Perfil = function (_React$Component) {
    _inherits(Perfil, _React$Component);

    function Perfil() {
        _classCallCheck(this, Perfil);

        return _possibleConstructorReturn(this, (Perfil.__proto__ || Object.getPrototypeOf(Perfil)).apply(this, arguments));
    }

    _createClass(Perfil, [{
        key: "render",
        value: function render() {
            var trigger = _react2.default.createElement(
                "span",
                { className: "avatar w-32" },
                this.props.imagem ? _react2.default.createElement(
                    "div",
                    { id: "imagem-perfil" },
                    _react2.default.createElement("img", { src: this.props.imagem, alt: "Imagem do Usu\xE1rio" })
                ) : _react2.default.createElement(_Icone2.default, { icone: "fa fa-user-circle" }),
                _react2.default.createElement(_Icone2.default, { icone: "on b-white bottom" })
            );

            return _react2.default.createElement(
                "li",
                { className: "nav-item dropdown" },
                _react2.default.createElement(
                    "a",
                    { className: "nav-link " },
                    _react2.default.createElement(
                        _semanticUiReact.Dropdown,
                        { trigger: trigger, pointing: "top right", icon: null },
                        _react2.default.createElement(
                            _semanticUiReact.Dropdown.Menu,
                            null,
                            _react2.default.createElement(_semanticUiReact.Dropdown.Item, { text: "Usuario", icon: "user" }),
                            _react2.default.createElement(_semanticUiReact.Dropdown.Item, { text: "Configura\xE7\xF5es", icon: "settings" }),
                            _react2.default.createElement(_semanticUiReact.Dropdown.Item, { text: "Sair", icon: "sign out" })
                        )
                    )
                )
            );
        }
    }]);

    return Perfil;
}(_react2.default.Component);

exports.default = Perfil;


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/perfil/PerfilHeader.js
// module id = 1132
// module chunks = 0